export default "__VITE_ASSET__213b92f5__"